import React from 'react';

export const RewardDropdown: React.FC = () => null;
